// extracted by mini-css-extract-plugin
export default {"text":"CustomRegisterCancelOption_text__nUQAY","registerimg":"CustomRegisterCancelOption_registerimg__etLnH"};